import { render } from "./otp.html?vue&type=template&id=504b7e28&external"
import script from "./otp.js?vue&type=script&lang=js&external"
export * from "./otp.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__